import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { join, remove } from 'lodash-es';

import { ViToastService } from '@vi-iot/ui';

import { MESSAGES } from './messages';

@Injectable({
  providedIn: 'root',
})
export class UpdateMessageService {
  private readonly updateMessages: { [key: string]: { success: string; error: string } };
  private defaultSuccess = '+SCHEDULES.SNACKBAR.PROGRAM_SUCCESS';
  private defaultError = '+SCHEDULES.SNACKBAR.PROGRAM_FAILURE';

  constructor(private translate: TranslateService, private toast: ViToastService) {
    this.updateMessages = MESSAGES;
  }

  success(customMessage: string, featureName: string, commandName: string): void {
    const message = customMessage
      ? customMessage
      : this.getMessage(featureName, commandName, 'success');
    this.toast.info({ message });
  }

  error(customMessage: string, featureName: string, commandName: string): void {
    const message = customMessage
      ? customMessage
      : this.getMessage(featureName, commandName, 'error');
    this.toast.error({ message });
  }

  private getMessage(featureName: string, commandName: string, type: 'success' | 'error'): string {
    const property = `${this.removeNumbers(featureName)}_${commandName}`;
    if (this.updateMessages[property] && this.updateMessages[property][type]) {
      const message = this.updateMessages[property][type];

      return this.translate.instant(message);
    } else {
      const message = type === 'success' ? this.defaultSuccess : this.defaultError;

      return this.translate.instant(message);
    }
  }

  private removeNumbers(featureName: string): string {
    // e.g. 'heating.circuits.2.dhw.schedule' -> 'heating.circuits.dhw.schedule'
    return join(
      remove(featureName.split('.'), (chunk) => isNaN(+chunk)),
      '.'
    ) as string;
  }
}
